// анимация истории
$(document).ready(function () {
  // window.scrollY || window.pageYOffset;/
  var mapPath = document.getElementById("mapPath");
  if (mapPath) {
    var t = mapPath.getTotalLength(),
      mapDot = document.getElementById("mapDot");
    mapDot.style.transition = "all .1s ease";
    var i = 0,
      o = mapPath.getPointAtLength(i),
      r = 100;
    let s = window.innerWidth;
    s > 1920 ? (r = 900) : s > 1440 ? (r = 700) : s > 768 && (r = 300);
    const a = document.querySelector(".map-container"),
      l = document.querySelector(".map-tree-container"),
      c = document.querySelector(".map-tree-container-dot"),
      u = document.querySelector(".roadmap__item--1"),
      d = document.querySelector(".roadmap__item--2"),
      p = document.querySelector(".roadmap__item--3");
    var f = !1,
      h = !1,
      v = !1,
      y = !1;

    function g() {
      if (i + 1 <= t)
        var r = mapPath.getPointAtLength(i + 1),
          s = Math.atan2(r.y - o.y, r.x - o.x);
      else {
        var a = mapPath.getPointAtLength(i - 1);
        s = Math.atan2(o.y - a.y, o.x - a.x);
      }
      mapDot.setAttribute(
        "transform",
        "translate(" + o.x + "," + o.y + ") rotate(" + (180 * s) / Math.PI + ")"
      );
    }

    function m() {
      var t, s, m, x, w, b, T, k, S;
      (s = (t = a.getBoundingClientRect()).top),
        (m = t.left),
        (x = t.bottom),
        (w = t.right),
        (b = document.documentElement.clientWidth),
        (T = document.documentElement.clientHeight),
        (k = 0),
        (S = 0),
        Math.min(T, x) - Math.max(0, s) >= S &&
          Math.min(b, w) - Math.max(0, m) >= k &&
          (f ||
            ((u.style.opacity = 1),
            new WOW({
              boxClass: "wowMap1",
              animateClass: "animated",
              offset: 0,
              mobile: !0,
              live: !1,
            }).init(),
            (f = !0)),
          (function () {
            var t = window.pageYOffset
              ? window.pageYOffset
              : document.documentElement.scrollTop
              ? document.documentElement.scrollTop
              : document.body.scrollTop;
            if (t > r && !y) {
              var s = t - r;
              l.setAttribute("style", "height:" + s + "px"),
                (i = s - 60),
                s > 65
                  ? ((mapDot.style.opacity = 1),
                    (l.style.opacity = 1),
                    (c.style.opacity = 1))
                  : ((mapDot.style.opacity = 0),
                    (l.style.opacity = 0),
                    (c.style.opacity = 0)),
                s > 423 &&
                  !h &&
                  ((d.style.opacity = 1),
                  new WOW({
                    boxClass: "wowMap2",
                    animateClass: "animated",
                    offset: 0,
                    mobile: !0,
                    live: !1,
                  }).init(),
                  (h = !0)),
                s > 699 &&
                  !v &&
                  ((p.style.opacity = 1),
                  new WOW({
                    boxClass: "wowMap3",
                    animateClass: "animated",
                    offset: 0,
                    mobile: !0,
                    live: !1,
                  }).init(),
                  (v = !0)),
                s > 1213 && (y = !0),
                (o = mapPath.getPointAtLength(i)),
                g();
            } else mapDot.style.opacity = 0;
          })());
    }
    g(),
      m(),
      window.addEventListener("scroll", function () {
        y
          ? (l.setAttribute("style", "height:100%!important"),
            (l.style.opacity = 1),
            (c.style.opacity = 0))
          : m();
      });
  }
});
